enum DynamicFormFieldType {
    TELEPHONE = 'tel',
    DROPDOWM = 'dropdown',
    NUMBER = 'number',
    PASSWORD = 'password',
    CHECKBOX = 'checkbox',
    MULTILINE = 'multiline',
    DATE = 'date',
    RADIO = 'radio',
    TEXT = 'text',
}

export default DynamicFormFieldType;
